export default __webpack_public_path__ + "static/media/AVISO-DE-PRIVACIDAD.a7563d40.pdf";